export const localization = {
    defaultLanguage: 'it',
    defaultLocale: 'it',
};